/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import store from './stores/Store';
import { getTradeStatistics } from '../db/TradeRequestHandler';
import { getIfFuncAuthorized } from '../utils/CheckSomething';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const styles = {
  // root: {
  //   '& .MuiTextField-root': {
  //     margin: '10px',
  //     width: '25ch',
  //   },
  // },
  paper: {
    padding: '8px',
    textAlign: 'center',
  },
};
class TradeStatisticsInner extends Component {
  constructor() {
    super();
    this.state = {
      count: {
        submit: 0, // 已提交
        selling: 0, // 销售中
        sold: 0, // 已销售
        // 房票信息统计:
        ticketCount: 0, // 发售房票张数
        ticketTotalAmount: 0, // 房票总金额
        // 成交信息统计:
        tradeTotalAmout: 0, // 销售总额
        ticketPaidTotalAmount: 0, // 房票使用额
        loanTotalAmount: 0, // 贷款总额
      },
    };

    this.getTradeStatistics = this.getTradeStatistics.bind(this);
  }

  async componentDidMount() {
    document.title = "交易记录统计";
    this.getTradeStatistics();
  }

  async getTradeStatistics() {
    if (!getIfFuncAuthorized('交易管理-交易记录统计')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    console.log(`----- getTradeStatistics: `);
    const rst = await getTradeStatistics({});
    console.log(`----- getTradeStatistics-rst:`, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      this.setState({
        count: rst.count,
      });
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {/* <Typography variant="h5" gutterBottom>
          交易记录统计
        </Typography> */}
        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  已提交：{this.state.count.submit || 0} 单
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  销售中：{this.state.count.selling || 0} 单
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  已销售：{this.state.count.sold || 0} 单
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  发售房票张数：{this.state.count.ticketCount || 0} 张
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  房票总金额：{this.state.count.ticketTotalAmount || 0} 元
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  销售总额：{this.state.count.tradeTotalAmout || 0} 元
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  房票使用额：{this.state.count.ticketPaidTotalAmount || 0} 元
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>
                <Typography variant="body1">
                  贷款总额：{this.state.count.loanTotalAmount || 0} 元
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const TradeStatistics = observer(TradeStatisticsInner);

TradeStatistics.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TradeStatistics);
